var map = {
	"./addlist.png": 9968,
	"./application/analysis.svg": 2336,
	"./application/detail-list.png": 4846,
	"./application/image-extra.png": 444,
	"./application/invent-idea.png": 5910,
	"./application/invent-panorama.png": 3742,
	"./application/note.png": 8960,
	"./application/popular.png": 6893,
	"./application/structured-content.png": 5541,
	"./application/tag-label.svg": 7831,
	"./application/terminology.png": 7195,
	"./arrow-bottom.png": 5592,
	"./assistant-white.png": 8081,
	"./assistant.png": 4853,
	"./attention.png": 2943,
	"./chaxin.png": 5178,
	"./deep.png": 2543,
	"./delete-black.png": 1062,
	"./docx.png": 5643,
	"./export.png": 1423,
	"./font.png": 9046,
	"./home.png": 4584,
	"./open.png": 8785,
	"./operate.png": 1369,
	"./pull.png": 7732,
	"./stop.svg": 6139,
	"./tool.png": 2859,
	"./uploadfile.png": 388,
	"./uploadfile2.png": 2476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8821;